import { type FC } from 'react';
import { usePersonalizedCollections } from 'dibs-personalized-collections/exports/PersonalizedCollectionsContext.ts';
import { SinglePersonalizedCollectionBannerLoading } from 'dibs-personalized-collections/exports/LazySinglePersonalizedCollectionBanner.ts';
import SuspendedSinglePersonalizedCollectionBanner from 'dibs-personalized-collections/exports/LazySinglePersonalizedCollectionBanner.ts';
import { useCurrency } from 'dibs-buyer-layout/exports/useCurrency.tsx';
import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';
import { useHomePageContext } from '../HomePageContext.tsx';

const MAX_BANNERS = 4;

type HpPersonalizedCollectionBannersProps = {
    bannerIndex?: number;
    onVisible?: () => void;
};

export const HpPersonalizedCollectionBanners: FC<HpPersonalizedCollectionBannersProps> = ({
    bannerIndex,
    onVisible,
}) => {
    const { bannerConfigs } = usePersonalizedCollections();
    const { currency } = useCurrency();
    const { isMobile } = useHomePageContext();

    const configs = bannerConfigs.slice(0, MAX_BANNERS);
    if (configs.length === 0) {
        return <SinglePersonalizedCollectionBannerLoading isMobile={isMobile} />;
    }

    if (bannerIndex !== undefined) {
        const config = configs[bannerIndex];
        if (!config) {
            return null;
        }

        return (
            <>
                {onVisible && (
                    <VisibilityTracker
                        onVisibilityChange={({ isVisible }) => {
                            if (isVisible) {
                                onVisible();
                            }
                        }}
                    />
                )}
                <SuspendedSinglePersonalizedCollectionBanner
                    key={config.collectionId}
                    collectionId={config.collectionId}
                    inspiredByItemId={config.inspiredByItemId ?? undefined}
                    backgroundColor={config.backgroundColor}
                    currency={currency}
                    isMobile={isMobile}
                    positionIndex={bannerIndex}
                />
            </>
        );
    }

    return null;
};
